import { SERVICE_URL } from 'services/ApiService';
import CredentialSerializer from '../CredentialSerializer';
import { get, startsWith } from 'lodash';
import ProfileSerializer from '../ProfileSerializer';
export default class AthleticTrainerSerializer {
  static deserialize(at) {
    const result = {
      id: at.id,
      createdAt: at.created_at,
      firstName: at.first_name,
      lastName: at.last_name,
      email: at.email,
      phoneNumber: at.phone_no,
      professionId: at.profession_id,
      errors: at.errors,
      shiftsWorked: at.shifts_worked,
      name: `${at.first_name} ${at.last_name}`,
      credentials: [],
      profile: ProfileSerializer.deserialize(at.profile),
      deCommits: at.de_commits,
      callouts: at.callouts,
      npiNumber: at.npi_id,
      nataNumber: at.nata_number,
      reliabilityScore: at.reliability_score,
      noShows: at.no_show_count,
      v2ReliabilityScore: at.v2_reliability_score,
    };

    if (get(at, 'credentials.length') > 0) {
      for (const credential of at.credentials) {
        result['credentials'].push(CredentialSerializer.deserialize(credential));
      }
    }

    if (at.profile_pic) {
      result['profilePic'] = at.profile_pic.includes('s3.amazonaws.com')
        ? at.profile_pic
        : !startsWith(at.profile_pic, SERVICE_URL)
          ? `${SERVICE_URL}${at.profile_pic}`
          : at.profile_pic;
    }

    return result;
  }

  static deserializeStatistics(userId, statistics) {
    const stats = statistics.statistics || {};
    const experience = statistics.experience || {};
    const reliability = statistics.reliability || {};

    return {
      userId,
      reliability: {
        currentScore: reliability.current_score,
        currentStreak: reliability.current_streak,
        reliabilityLogs: reliability.reliability_impact_logs.map(this.deserializeReliabilityLog),
        scoreTrend: (reliability.score_trend || []).map(t => ({
          m: t.month.toUpperCase(),
          v: Math.round((t.score || 0) * 10),
          date: t.date || null,
        })),
      },
      jobCount: stats.job_count || 0,
      last6MonthsJobCount: stats.last_6_months_job_count || 0,
      calloutUnder1Day: stats.callout_under_1_day || 0,
      callout1To3Days: stats.callout_1_to_3_days || 0,
      callout3To7Days: stats.callout_3_to_7_days || 0,
      totalCallouts: stats.total_callouts || 0,
      noShowCount: stats.no_show_count || 0,
      organizationsWorkedWith: experience.organizations_worked_with || 0,
      withYou: {
        jobs: stats.with_you?.jobs || 0,
        callouts: stats.with_you?.callouts || 0,
        noShows: stats.with_you?.no_shows || 0,
      },
      experience: {
        sports: experience.sports_worked || [],
        settings: experience.settings_worked || [],
        onGo4Since: experience.on_go4_since,
      },
      messageForEo: stats.message_for_eo,
    };
  }

  static deserializeReliabilityLog = log => {
    return {
      id: log.id,
      classification: log.classification,
      occurredAt: log.occurred_at,
      impact: log.impact,
    };
  };
}
